import { AfterViewChecked, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { SearchService } from '../search.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-checklist',
    templateUrl: './checklist.component.html',
    styleUrl: './checklist.component.scss',
    standalone: true,
    imports: [CommonModule, FormsModule, DragDropModule],
})
export class ChecklistComponent implements AfterViewChecked {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() userId: string = "";
  @Input() fieldKey: string = "";
  @Input() contentKey: string = "";
  @Input() tableJson = "";
  @Input() aggregatedContent: string = "";
  @Output() listenTable = new EventEmitter<{ "table": string, "fieldKey": string }>();
  isLoadingLabelVisible: boolean = false;
  loadingMessage: string = "Generating checklist..."
  items: { "name": string, "checked": boolean, "order": number }[] = [];

  @ViewChildren('itemInput') itemInputs: QueryList<any>; // Query for all inputs

  private focusNewItem: boolean = false; // track if focus needs to be set

  constructor(private search: SearchService) {}

  ngAfterViewInit() {
    if (this.tableJson != "") {
      this.convertToArray()
    }
  }

  ngAfterViewChecked() {
    if (this.focusNewItem && this.itemInputs && this.itemInputs.last) {
      this.itemInputs.last.nativeElement.focus(); // focus the last input
      this.focusNewItem = false; // Reset the flag
    }
  }

  convertToArray() {
    this.items = JSON.parse(this.tableJson)
    this.items.sort((a, b) => a.order - b.order)
  }

  updateJsonField() {
    this.listenTable.emit({ "table": this.tableJson, "fieldKey": this.fieldKey });
  }

  addItem() {
    this.items.push({ "name": "", "checked": false, "order": this.items.length });
    this.convertToJson();
    this.focusNewItem = true; // set the flag to focus newly added item
  }

  removeItem(index: number) {
    this.items.splice(index, 1)
    this.convertToJson();
  }

  updateItem(index: number, itemName: string) {
    this.items[index].name = itemName;
    this.convertToJson();
  }

  checkItem(index: number) {
    this.items[index].checked = !this.items[index].checked;
    this.convertToJson();
  }

  convertToJson() {
    this.tableJson = JSON.stringify(this.items);
    this.updateJsonField();
  }

  changeOrder(event: any) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.convertToJson();
  }

  handleKeydown(event: KeyboardEvent, index: number) {
    if (event.key === 'Enter') {
      event.preventDefault();  // Prevent the default action of the Enter key (e.g., form submission)
      this.addItem();  // Add a new item
      // Optionally focus the new input field if needed
      setTimeout(() => {
        const inputs = document.querySelectorAll('input[type="text"]');
        const nextInput = inputs[index + 1] as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      });
    }
    if (event.shiftKey && event.key == 'Backspace') {
      event.preventDefault();  // Prevent the default action of the Enter key (e.g., form submission)
      this.removeItem(index)
      if (this.items.length > 0) {
        setTimeout(() => {
          const inputs = document.querySelectorAll('input[type="text"]');
          const nextInput = inputs[this.items.length - 1] as HTMLInputElement;
          if (nextInput) {
            nextInput.focus();
          }
        });
      }
    }
  }

  generateChecklist() {
    this.isLoadingLabelVisible = true
    this.search.getGPTChatResponse("Generate a checklist for the following content. Return only the checklist, no other text or comments in JSON format ['name' : <itemName>}, ...]. \n\n" + this.aggregatedContent+"\n\n", "gpt-4.1-mini").then((response) => {
      this.isLoadingLabelVisible = false
      const newItems: any[] = this.search.extractJsonFromString(response)
      newItems.forEach(item => {
        this.items.push({
          name: item.name,
          checked: false,
          order: this.items.length, 
        });
      });
      this.convertToJson()
    }).catch(() => {
      this.isLoadingLabelVisible = false
    })
  }
}
